var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginateFirstPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.773438 7.22656L6.46094 12.9141C6.86198 13.3151 7.26302 13.3151 7.66406 12.9141C7.84635 12.7318 7.9375 12.5312 7.9375 12.3125C7.9375 12.0573 7.84635 11.8568 7.66406 11.7109L2.63281 6.625L7.66406 1.53906C8.10156 1.13802 8.10156 0.736979 7.66406 0.335938C7.26302 -0.0651042 6.86198 -0.0651042 6.46094 0.335938L0.773438 6.02344C0.591146 6.16927 0.5 6.36979 0.5 6.625C0.5 6.88021 0.591146 7.08073 0.773438 7.22656Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginateFirstPage);
export default __webpack_public_path__ + "static/media/paginate-first-page.24d34f26ed165f1ebe496d56dd26d8d6.svg";
export { ForwardRef as ReactComponent };